import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SelfEfficacy',
    label: 'SelfEfficacy',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
